// src/components/layout/Navigation.js
import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { FaTasks, FaChartLine, FaUsers, FaCog, FaSignOutAlt, FaUser, FaStar, FaEnvelope } from 'react-icons/fa';
import { logoutUser } from '../../features/auth/authSlice';

const Navigation = () => {
    const { user } = useSelector(state => state.auth);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = () => {
            setIsProfileDropdownOpen(false);
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const handleLogout = () => {
        dispatch(logoutUser());
        navigate('/login');
    };

    const toggleProfileDropdown = (e) => {
        e.stopPropagation();
        setIsProfileDropdownOpen(!isProfileDropdownOpen);
    };

    // Navigation items based on user role
    const navigationItems = [
        {
            path: '/dashboard',
            label: 'Dashboard',
            icon: <FaChartLine />,
            roles: ['user', 'admin', 'super_admin']
        },
        {
            path: '/tasks',
            label: 'Tasks',
            icon: <FaTasks />,
            roles: ['user', 'admin', 'super_admin']
        },
        {
            path: '/admin/users',
            label: 'User Management',
            icon: <FaUsers />,
            roles: ['admin', 'super_admin']
        },
        {
            path: '/admin/reviews',
            label: 'Review Management',
            icon: <FaStar />,
            roles: ['admin', 'super_admin']
        },
        {
            path: '/admin/contacts',
            label: 'Contact Management',
            icon: <FaEnvelope />,
            roles: ['admin', 'super_admin']
        }/*,
        {
            path: '/admin/settings',
            label: 'System Settings',
            icon: <FaCog />,
            roles: ['super_admin']
        }*/
    ];

    const filteredNavItems = navigationItems.filter(
        item => !item.roles || item.roles.includes(user?.role)
    );

    return (
        <nav className="main-navigation">
            <div className="nav-container">
                <div className="nav-brand">
                    <Link to="/">
                        <div className="logo">
                            <FaTasks />
                            <span>TaskPriority</span>
                        </div>
                    </Link>

                    <button
                        className="mobile-menu-toggle"
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </div>

                <div className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
                    <ul className="nav-links">
                        {filteredNavItems.map(item => (
                            <li key={item.path}>
                                <Link
                                    to={item.path}
                                    className={location.pathname === item.path ? 'active' : ''}
                                >
                                    {item.icon}
                                    <span>{item.label}</span>
                                </Link>
                            </li>
                        ))}
                    </ul>

                    <div className="nav-profile">
                        <div
                            className="profile-info"
                            onClick={toggleProfileDropdown}
                        >
                            <div className="profile-avatar">
                                {user?.first_name?.charAt(0)}{user?.last_name?.charAt(0)}
                            </div>
                            <div className="profile-name">
                                <span>{user?.first_name} {user?.last_name}</span>
                                <small>{user?.role}</small>
                            </div>
                        </div>

                        {isProfileDropdownOpen && (
                            <div className="profile-dropdown">
                                <Link to="/profile" className="dropdown-item">
                                    <FaUser />
                                    <span>My Profile</span>
                                </Link>
                                <div
                                    className="dropdown-item logout"
                                    onClick={handleLogout}
                                >
                                    <FaSignOutAlt />
                                    <span>Logout</span>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navigation;